import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const ViewModal = ({ show, handleClose, isEdit }) => {

    return (
        <>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5 text-center">View Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div class="row">
                        <div class="col-md-12 mb-2">
                            <span style={{fontWeight: 'bold'}}>Broker Name</span>
                            <p>{isEdit?.broker_name}</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Broker Email</span>
                            <p>{isEdit?.broker_email}</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Phone Number:</span>
                            <p>{isEdit?.phone_number}</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Description:</span>
                            <p>{isEdit?.description}</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Created At</span>
                            <p>
                                <span class="badge bg-info">
                                    {isEdit?.created_at}
                                </span>
                            </p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Updated At</span>
                            <p>
                                <span class="badge bg-info">
                                    {isEdit?.updated_at}
                                </span>
                            </p>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ViewModal;